/** Pilot Cashfree (no JWT on these routes). */

const LOG_PREFIX = '[V2Pay:payments]';

function pilotBaseUrl() {
  return (process.env.REACT_APP_PILOT_URL || '').replace(/\/$/, '');
}

function logPayments(event, payload = {}) {
  console.info(LOG_PREFIX, event, payload);
}

/**
 * @param {{ amount: number, mobileNo: string, customerId: string, platform?: string, orderDetails: object, version?: string }} body
 * @returns {Promise<{ order_id: string, payment_session_id: string }>}
 */
export async function pilotCreateCashfreeSession(body) {
  const base = pilotBaseUrl();
  if (!base) {
    console.error(LOG_PREFIX, 'missing_REACT_APP_PILOT_URL');
    throw new Error('REACT_APP_PILOT_URL is not configured');
  }
  const url = `${base}/api/payments/cashfree/order`;
  logPayments('cashfree_order_request', {
    url,
    amount: body?.amount,
    platform: body?.platform,
    cashfreeFlow: body?.orderDetails?.cashfreeFlow,
    hasOrderDetails: Boolean(body?.orderDetails),
  });
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      accept: 'application/json',
    },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  logPayments('cashfree_order_response', {
    ok: res.ok,
    status: res.status,
    has_order_id: Boolean(data.order_id),
    has_payment_session_id: Boolean(data.payment_session_id),
    error: data.error ?? null,
    message: data.message ?? null,
  });
  if (!res.ok || data.error || !data.order_id || !data.payment_session_id) {
    const msg =
      typeof data.error === 'string'
        ? data.error
        : data.message || 'Could not start payment. Try again.';
    console.error(LOG_PREFIX, 'cashfree_order_rejected', { status: res.status, msg });
    throw new Error(msg);
  }
  return data;
}

/** Native bridge: list payments after SDK success (same as pilot in-store flow). */
export async function pilotCashfreeOrderPayments(orderId) {
  const base = pilotBaseUrl();
  if (!base) throw new Error('REACT_APP_PILOT_URL is not configured');
  logPayments('order_payments_request', { orderId: String(orderId).slice(0, 14) + '…' });
  const res = await fetch(`${base}/api/payments/cashfree/order-payments`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      accept: 'application/json',
    },
    body: JSON.stringify({ orderId }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    console.error(LOG_PREFIX, 'order_payments_failed', { status: res.status, error: data.error });
    throw new Error(data.error || 'Could not confirm payment with server.');
  }
  logPayments('order_payments_ok', { status: res.status });
  return res.json();
}
